export default __webpack_public_path__ + "static/media/cat2-2-2.d4925486.jpg";